/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Tile_item$ref = any;
export type ItemPreviews_item$ref = any;
export type ItemPreviews_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly contemporaryTrackingString: string;
    readonly categoryPath: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly pricing: {
        readonly retailPrice: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly firstPhotoWebPath: string | null;
    readonly " $fragmentRefs": Tile_item$ref;
    readonly " $refType": ItemPreviews_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ItemPreviews_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "showSeller",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "isTrade",
                "type": null
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "contemporaryTrackingString",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryPath",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "retailPrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "amount",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstPhotoWebPath",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "size",
                        "value": "large"
                    }
                ],
                "storageKey": "firstPhotoWebPath(size:\"large\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "Tile_item",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTrade",
                        "variableName": "isTrade"
                    },
                    {
                        "kind": "Variable",
                        "name": "showSeller",
                        "variableName": "showSeller"
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '1b63108b94c1b1a561b759f4bb5af0d1';
export default node;
